"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchUpdatePaymentStatus = batchUpdatePaymentStatus;
exports["default"] = void 0;
exports.getCpd = getCpd;
exports.requestEpdConfirmation = requestEpdConfirmation;
exports.searchExpertPayments = searchExpertPayments;
exports.updateCpd = updateCpd;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function searchExpertPayments(query) {
  return _api["default"].post('/api/report/expert-payment', query).then(_api.extractData)["catch"](_api.errorHandler);
}

function batchUpdatePaymentStatus(ids, status) {
  return _api["default"].put('/api/consultation-payment-detail/batch-status', {
    ids: ids,
    status: status
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getCpd(cpdId) {
  return _api["default"].get("/api/consultation-payment-detail/".concat(cpdId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateCpd(cpdId, data) {
  return _api["default"].put("/api/consultation-payment-detail/".concat(cpdId), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function requestEpdConfirmation(epd, feeId) {
  return _api["default"].put("/api/expert-payment-detail/".concat(epd.expertId, "/request-details"), _objectSpread(_objectSpread({}, epd), {}, {
    feeId: feeId
  })).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  searchExpertPayments: searchExpertPayments,
  batchUpdatePaymentStatus: batchUpdatePaymentStatus,
  getCpd: getCpd,
  updateCpd: updateCpd,
  requestEpdConfirmation: requestEpdConfirmation
};
var _default = api;
exports["default"] = _default;